import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./FoodrnaContactUs.css";
import { Link } from "react-router-dom";

const FoodrnaContactUs = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-foodrna">
      <div className="header-contact-foodrna">
        <h2>{t("foodarna.contact.heading.line1")}</h2>
        <h2>{t("foodarna.contact.heading.line2")}</h2>
        <p className="!mt-2">{t("foodarna.contact.text")}</p>
        <div className="button-wrapper !mt-3">
          <Link className="btn" to="/contact">
            {t("foodarna.contact.button")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FoodrnaContactUs;
